import { useEffect, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useUser } from "../atoms";
import { linksRequestNumberState, preferitiRequestNumberState } from "../atoms/portale";
import { editPrefShowAtom } from "../atoms/preferito";
import { NullableString, Preferito, PreferitoToSaveDto, ServiceDescriptor } from "../models/ServiceDescriptor";
import apiService from "../services/api";
import SavePreferitoModal from "./SavePreferitoModal";

function EditPreferito() {
    const [editPrefShow, setEditPrefShow] = useRecoilState(editPrefShowAtom)
    const user = useUser()
    const userCtx = user?.context
    const setPreferitoRequestNumber = useSetRecoilState(preferitiRequestNumberState)
    const setLinksRequestNumber = useSetRecoilState(linksRequestNumberState)
    const handleOnHideSavePref = () => setEditPrefShow({ show: false, appl: undefined, preferito: undefined });
    const [preferito, setPreferito] = useState<Preferito>()

    useEffect(() => {
        if (editPrefShow.preferito) {
            //Edit
            setPreferito({
                id: editPrefShow.preferito.id,
                groupDescriptorId: editPrefShow.preferito.groupDescriptorId,
                serviceDescriptorId: editPrefShow.preferito.serviceDescriptorId,
                serviceDescriptor: editPrefShow.appl!,
                userId: userCtx?.name ?? '',
                title: editPrefShow.preferito.title,
                descriUrl: editPrefShow.preferito.descriUrl,
                contesto: editPrefShow.preferito.contesto,
                contestoDescri: editPrefShow.preferito.contestoDescri,
                iconName: editPrefShow.iconName ?? '',
                color: editPrefShow.color ?? '',
                dataUltimoLancio: editPrefShow.preferito.dataUltimoLancio,
                url: editPrefShow.preferito.url,
            })
        } else {
            //Insert
            setPreferito({
                id: 0,
                groupDescriptorId: 0,
                serviceDescriptorId: 0,
                serviceDescriptor: editPrefShow.appl!,
                userId: userCtx?.name ?? '',
                title: '',
                descriUrl: '',
                contesto: '',
                contestoDescri: null,
                iconName: '',
                color: '',
                dataUltimoLancio: null,
                url: '',
            })
        }
    }, [editPrefShow, userCtx?.name])

    const handleOnSavePref = (sd: ServiceDescriptor, descri: NullableString, codice: NullableString, preferito: Preferito) => {
        // console.log('Sono in Save preferito con sd', sd)
        const prefToSave: PreferitoToSaveDto = {
            groupDescriptorId: sd.groupDescriptorId === 0 ? null : sd.groupDescriptorId,
            serviceDescriptorId: sd.id === 0 ? null : sd.id,
            userId: userCtx?.name ?? '',
            title: sd.id !== 0 ? sd.urlDescription : preferito.title,
            descriUrl: descri,
            contesto: codice,
            contestoDescri: null,
            iconName: preferito.iconName,
            color: preferito.color,
            url: preferito.url
        }
        // console.log('sto per chiamare api con preferito', prefToSave)
        apiService.savePreferito(prefToSave, preferito.id).then(() => {
            if (prefToSave.serviceDescriptorId) { 
                setPreferitoRequestNumber(rn => rn + 1) 
            } else {
                setLinksRequestNumber(rn => rn + 1)
            }
            handleOnHideSavePref()   //Close the modal
        })
        // console.log(`handleOnSavePref ${sd.id} - ${sd.urlDescription}, ${codice}`)
    }

    const handleOnCheckPreferito = async (sd: ServiceDescriptor, context: NullableString) => {
        // console.log(`handleOnCheckPreferito: ${sd.id} - ${context}`)
        // Controlla con la api l'esistenza di un preferito con queste caratteristiche
        var rv = await apiService.checkPrefExistence(sd.id, context, preferito!)
        // console.log(`handleOnCheckPreferito: ${sd.id} - ${context} => `, rv)
        // console.log('handleOnCheckPreferito return', rv)
        if (!rv) return { exists: true }
        return rv
    }

    return (
        <SavePreferitoModal
            open={editPrefShow.show}
            onHide={handleOnHideSavePref}
            onSave={handleOnSavePref}
            onCheckPreferito={handleOnCheckPreferito}
            sd={editPrefShow.appl}
            context={userCtx?.ufficioCorrente}
            preferitoInEdit={preferito!} //Ti assicuro che il preferito in Edit è presente 
            user={user}
            title={editPrefShow.title}
        />
    )
}

export default EditPreferito;